import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import {default as React} from 'react';
import StageManagement from '../component/grid/ManagementGrid';

const ManagerPage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Instance management</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <StageManagement />
    </>
  );
};

export default ManagerPage;
